// @flow
export const Metric = {
  RATE: 'rate',
  TOTAL: 'total',
};

export const Precision = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
  MONTHLY_AND_YEARLY: 'monthlyAndYearly', // used only for export
};

export const Compare = {
  NONE: 'none',
  YEAR: 'year',
  PERIOD: 'period',
  RECURRING: 'recurring',
  CUSTOM: 'custom',
};

export const Timespan = {
  LAST_MONTH: 'lastMonth',
  LAST_12_MONTHS: 'last12Months',
  THIS_YEAR: 'thisYear',
  LAST_YEAR: 'lastYear',
  LAST_5_YEARS: 'last5Years',
  FROM_2010: 'from2010',
  FROM_2000: 'from2000',
  FROM_1990: 'from1990',
  CUSTOM: 'custom',
};

export const MetricProp = {
  [Metric.RATE]: 'rate',
  [Metric.TOTAL]: 'crimes',
};

export const Sort = {
  NAME: 'name',
  TIMESPAN: 'timespan',
  POPULATION: 'population',
  TOTAL: 'total',
  RATE: 'rate',
  TI_1_MURDERS: 'firstIntervalMurders',
  TI_2_MURDERS: 'secondIntervalMurders',
  TI_1_RATE: 'firstIntervalRate',
  TI_2_RATE: 'secondIntervalRate',
  TI_1_POPULATION: 'firstIntervalPopulation',
  TI_2_POPULATION: 'secondIntervalPopulation',
};

export const VisType = {
  TABLE: 'table',
  MAP: 'map',
  LINE: 'lineChart',
  SINGLE: 'singleIntervalChart',
  DIFFERENCE: 'differenceChart',
  COMPARISON: 'comparisonChart',
  RECURRING: 'recurringChart',
};

export type Vis = $Keys<typeof VisType>;

export const ExportFileFormat = {
  CSV: '.csv',
  // XLS: '.xlsx',
};

export const ExportSource = {
  ALL: 'All',
  SELECTED: 'Selected',
};

export const ExportTimeSource = {
  ALL_MONTHLY: 'All Time Monthly',
  ALL_YEARLY: 'All Time Yearly',
  ALL_MONTHLY_AND_YEARLY: 'All Time Yearly and Monthly',
  SELECTED: 'Selected Time',
};



// WEBPACK FOOTER //
// ./src/constants.js